"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _snakecaseKeys = _interopRequireDefault(require("snakecase-keys"));
var _utils = require("../utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var camelizeResponse = function camelizeResponse(response) {
  return _objectSpread(_objectSpread({}, response), {}, {
    data: (0, _utils.toCamelCase)(response.data)
  });
};
var snakeCaseRequest = function snakeCaseRequest(config, disableSnakeCaseRequest) {
  if (!config.data) {
    return config;
  }
  return _objectSpread(_objectSpread({}, config), {}, {
    data: disableSnakeCaseRequest ? config.data : (0, _snakecaseKeys.default)(config.data)
  });
};
var RestClient = /*#__PURE__*/(0, _createClass2.default)(function RestClient(_config, _ref) {
  var _this = this;
  var clientId = _ref.clientId;
  (0, _classCallCheck2.default)(this, RestClient);
  (0, _defineProperty2.default)(this, "client", void 0);
  (0, _defineProperty2.default)(this, "config", void 0);
  (0, _defineProperty2.default)(this, "clientId", void 0);
  (0, _defineProperty2.default)(this, "get", function (url, config) {
    return _this.client.get(url, config);
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (0, _defineProperty2.default)(this, "put", function (url, data, config) {
    return _this.client.put(url, data, config);
  });
  (0, _defineProperty2.default)(this, "delete", function (url, config) {
    return _this.client.delete(url, config);
  });
  (0, _defineProperty2.default)(this, "head", function (url, config) {
    return _this.client.head(url, config);
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (0, _defineProperty2.default)(this, "post", function (url, data, config) {
    return _this.client.post(url, data, config);
  });
  (0, _defineProperty2.default)(this, "withVersion", function (newVersion, callback) {
    var client = _this.getClientForVersion(newVersion);
    return callback(client);
  });
  (0, _defineProperty2.default)(this, "getClient", function () {
    var client = _axios.default.create(_objectSpread({
      baseURL: _this.config.apiURL,
      headers: _this.getHeaders()
    }, _this.config.axiosConfig));
    client.interceptors.request.use(function (config) {
      return snakeCaseRequest(config, _this.config.disableSnakeCaseRequest);
    });
    client.interceptors.response.use(camelizeResponse);
    return client;
  });
  (0, _defineProperty2.default)(this, "getHeaders", function () {
    var headers = {
      'Content-Type': 'application/json'
    };
    if (_this.config.accessToken) {
      // eslint-disable-next-line dot-notation
      headers['Authorization'] = "Bearer ".concat(_this.config.accessToken);
    }
    if (!_this.config.aps) {
      // eslint-disable-next-line dot-notation
      headers['client'] = _this.clientId;
    }
    if (_this.config.computeHours) {
      headers['COMPUTE-HOURS-LOGGED'] = _this.config.computeHours;
    }
    if (_this.config.xClientRest) {
      headers['x-client'] = _this.config.xClientRest;
    }
    return headers;
  });
  this.config = _config;
  this.clientId = clientId;
  this.client = this.getClient();
});
var _default = RestClient;
exports.default = _default;